<template>
  <CardComponent class="kpi-single" ref="kpiSingle" :class="{clickable}" @click="() => {if(clickable)$emit('clicked')}">
    <span class="kpi-title">{{ title }}</span>
    <span class="kpi-number" :class="kpiColorClass">{{ kpi }}</span>
    <span class="kpi-interval">{{ interval }}</span>
    <span class="kpi-trend"><span>{{ trend }}</span> <component v-bind="iconProps" :is="trendComponent"/></span>
    <span class="kpi-menu" v-if="showDropdownMenu" @click="showDropdown = !showDropdown">&vellip;</span>
    <div
      class="kpi-dropdown"
      :class="{show: showDropdown, 'position-left': dropdownPositionLeft}"
      v-click-outside="{
        handler: () => {showDropdown = false},
        closeConditional: () => showDropdown
      }">
      <slot :closeDropdown="closeDropdown"></slot>
    </div>
  </CardComponent>
</template>

<script>
import CardComponent from "@/components/form/CardComponent";
import TrendDownIcon from "@/components/icons/TrendDownIcon";
import {computed, ref, onMounted} from "@vue/composition-api";
import TrendUpIcon from "@/components/icons/TrendUpIcon";
import NoTrendIcon from "@/components/icons/NoTrendIcon";

const trendDirections = {
  UP: 0,
  DOWN: 1,
  FLAT: 2
}

const colors = {
  GREEN: 0,
  RED: 1,
  GRAY: 2
}

export default {
  name: "KpiSingleComponent",
  components: {TrendDownIcon, TrendUpIcon, NoTrendIcon, CardComponent},
  props: {
    title: String,
    kpi: [String, Number],
    kpiColor: Number,
    interval: String,
    trend: String,
    trendDirection: Number,
    trendIconColor: Number,
    showDropdownMenu: {
      type: Boolean,
      default: false
    },
    clickable:{
      type: Boolean,
      default: false
    }
  },
  setup(props, {refs}) {

    const dropdownPositionLeft = ref(false)
    onMounted(() => {
      function setDorpdownPosition(){
        let vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
        let dropdownRigth = refs.kpiSingle.$el.getBoundingClientRect().right + 172
        dropdownPositionLeft.value = vw < dropdownRigth
      }
      setDorpdownPosition()
      window.addEventListener('resize', setDorpdownPosition)
    })

    const showDropdown = ref(false)

    const trendComponent = computed(() => {
      switch (props.trendDirection) {
        case trendDirections.UP:
          return 'TrendUpIcon'
        case trendDirections.DOWN:
          return 'TrendDownIcon'
        case trendDirections.FLAT:
          return 'NoTrendIcon'
      }
    })

    const iconProps = computed(() => {
      switch (props.trendIconColor) {
        case colors.RED:
          return {red: true}
        case colors.GREEN:
          return {green: true}
        case colors.GRAY:
          return {gray: true}
      }
    })

    const kpiColorClass = computed(() => {
      if (typeof props.kpiColor !== 'undefined') {
        switch (props.kpiColor) {
          case colors.RED:
            return 'kpi-red'
          case colors.GREEN:
            return 'kpi-green'
          case colors.GRAY:
            return 'kpi-gray'
        }
      }
      if (typeof props.trendIconColor !== 'undefined') {
        switch (props.trendIconColor) {
          case colors.RED:
            return 'kpi-red'
          case colors.GREEN:
            return 'kpi-green'
          case colors.GRAY:
            return 'kpi-gray'
        }
      }
      if (typeof props.trendDirection !== 'undefined') {
        switch (props.trendDirection) {
          case trendDirections.DOWN:
            return 'kpi-red'
          case trendDirections.UP:
            return 'kpi-green'
          case trendDirections.FLAT:
            return 'kpi-gray'
        }
      }
      return 'kpi-gray'
    })

    function closeDropdown() {
      showDropdown.value = false
    }

    return {trendComponent, iconProps, kpiColorClass, showDropdown, closeDropdown, dropdownPositionLeft}
  }
}

export {trendDirections, colors}
</script>

<style scoped lang="scss">
.kpi-single {
  color: map-get($grey, 'lighten-blue-1');
  display: flex;
  font-size: 17px;
  width: 214px;
  height: 160px;

  .kpi-number {
    font-size: 50px;
    font-weight: 500;
    margin: auto;

    &.kpi-green {
      color: map-get($green, 'darken-1');
    }

    &.kpi-red {
      color: map-get($pink, 'darken-1');
    }

    &.kpi-gray {
      color: map-get($grey, 'dark');
    }
  }

  .kpi-title {
    position: absolute;
    top: 8px;
    left: 12px;
    font-weight: 500;
  }

  .kpi-interval {
    position: absolute;
    left: 12px;
    bottom: 8px;
  }

  .kpi-trend {
    position: absolute;
    right: 12px;
    bottom: 8px;
    display: flex;
    align-items: center;

    span {
      padding-right: 5px;
    }
  }

  &.clickable {
    cursor: pointer;
  }

  .kpi-menu {
    position: absolute;
    top: 0;
    right: 2px;
    cursor: pointer;
    font-size: 26px;
    padding: 0 8px;
  }

  .kpi-dropdown {
    position: absolute;
    top: 8px;
    left: calc(100% - 8px);
    z-index: 1;
    background-color: white;
    border-radius: 5px;
    box-shadow: 0 6px 10px rgba(0, 0, 0, 0.16);
    display: none;
    overflow: hidden;
    width: 180px;

    &.position-left {
      left: auto;
      right: 22px;
    }

    &.show {
      display: flex;
    }
  }
}
</style>
